import { PageController } from '@client/components/_core/layout/PageController';
import { ORG_CONFIG_PERMISSIONS } from '@shared/permissions/permissions';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Settings } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/configuration')({
    staticData: {
        breadcrumb: {
            title: 'Control centre',
        },
        permissions: ORG_CONFIG_PERMISSIONS,
        ui: {
            icon: Settings,
        },
    },
    component: Configuration,
});

function Configuration() {
    return (
        <PageController route={Route}>
            <Outlet />
        </PageController>
    );
}
